export default "__VITE_ASSET__CGmW7Bp3__"